import type { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { CloseButton, Text } from '@/shared/ui';
import { BackButton } from './BackButton';

type Props = {
  title?: string;
  onBack?: () => void;
  additionalMenuItems?: ReactNode;
  onClose: () => void;
};

export const SideMenuHeader: FC<Props> = ({ title, additionalMenuItems, onClose, onBack }) => {
  const { t } = useTranslation();
  return (
    // heightはPageHeaderのbottomBorderに合わせるため49pxにしている
    <div className="sticky top-0 flex h-[49px] shrink-0 items-center justify-between border-b bg-white px-4">
      <div className="flex items-center gap-2">
        {onBack && <BackButton onBack={onBack} />}
        {title && <Text variant="subhead">{title}</Text>}
      </div>
      <div className="flex items-center justify-center gap-2">
        {additionalMenuItems && additionalMenuItems}
        <CloseButton onClick={onClose} aria-label={t('ai.common.close-panel')} />
      </div>
    </div>
  );
};
